// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"b91be53d","167":"b91be53d","271":"5a8ef762","726":"f70b3c65","989":"0fc681ba"}[chunkId] + ".css";
};